import { render, staticRenderFns } from "./pagos.vue?vue&type=template&id=d3b85634&"
import script from "./pagos.vue?vue&type=script&lang=js&"
export * from "./pagos.vue?vue&type=script&lang=js&"
import style0 from "./pagos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports